var React = require('react');

function ArrowRightMain (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m18.6244 13.0836-3.9046-3.90451c-.4433-.44328-.4433-1.16198 0-1.60526.4433-.44327 1.162-.44327 1.6053.00001l6.0574 6.05746c.3905.3905.3905 1.0237 0 1.4142l-6.0575 6.0574c-.4432.4433-1.1619.4433-1.6052 0s-.4433-1.162 0-1.6052l4.0002-4.0003h-10.98869c-.66655 0-1.2069-.5403-1.2069-1.2069 0-.6665.54035-1.2069 1.2069-1.2069z","fill":"#6235ff","fillRule":"evenodd"}));
}

ArrowRightMain.defaultProps = {"fill":"none","height":"28","viewBox":"0 0 28 28","width":"28"};

module.exports = ArrowRightMain;

ArrowRightMain.default = ArrowRightMain;
